import { render, staticRenderFns } from "./ArticleTitle.vue?vue&type=template&id=6c8f35c3&"
import script from "./ArticleTitle.vue?vue&type=script&lang=ts&"
export * from "./ArticleTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports